import { useEffect, useState, useContext } from "react";
import swal from "sweetalert";
import axios from "axios";
import { NavLink, useLocation } from "react-router-dom";
import { getApiUrl } from "../../../helpers/helperApp";
import { LoginContext } from "../../../hooks/context/LoginContext";
import { Fragment } from "react";
import SpinnerFullScreen from "../../ui/SpinnerFullScreen";

function MenuSuperAdmin({ miNivel, activeMenuColor, confApp }) {
  const { apiKey } = useContext(LoginContext);
  const location = useLocation();

  const [regenerando, saveRegenerando] = useState(false);
  const [textoRegenerando, saveTextoRegenerando] = useState(false);
  const [estReg, saveEstReg] = useState("");
  const [respReg, saveRespReg] = useState("");
  
  // Estado unificado para controlar qué menú está abierto.
  // null = ninguno, 1 = Documentos, 2 = Stock, etc.
  const [openMenu, setOpenMenu] = useState(null); 

  useEffect(() => {
    let newActual = 0;

    if (
      location.pathname.includes("/documentos") ||
      location.pathname.includes("/tipdoc") ||
      location.pathname.includes("/estdoc") ||
      location.pathname.includes("/apartados") ||
      location.pathname.includes("/edirap") ||
      location.pathname.includes("/planificador") ||
      location.pathname.includes("/runciccfg") ||
      location.pathname.includes("/gesdoc") ||
      location.pathname.includes("/checklist")
    ) {
      newActual = 1;
    } else if (
      location.pathname.includes("/stockubi") ||
      location.pathname.includes("/stockmov") ||
      location.pathname.includes("/supply") ||
      location.pathname.includes("/stockart") ||
      location.pathname.includes("/stockreu")
    ) {
      newActual = 2;
    } else if (
      location.pathname.includes("/articulos") ||
      location.pathname.includes("/tipuni")
    ) {
      newActual = 3;
    } else if (
      location.pathname.includes("/agentes") ||
      location.pathname.includes("/tipage")
    ) {
      newActual = 4;
    } else if (
      location.pathname.includes("/equipos") ||
      location.pathname.includes("/tipobj")
    ) {
      newActual = 5;
    } else if (
      location.pathname.includes("/centros") ||
      location.pathname.includes("/tipcen")
    ) {
      newActual = 6;
    } else if (
      location.pathname.includes("/loginusu") ||
      location.pathname.includes("/tipgf") ||
      location.pathname.includes("/loginnvl") ||
      location.pathname.includes("/permisosusu")
    ) {
      newActual = 7;
    } else if (
      location.pathname.includes("/tipadj") ||
      location.pathname.includes("/paises") ||
      location.pathname.includes("/provincias") ||
      location.pathname.includes("/appcfg") ||
      location.pathname.includes("/apptrad") ||
      location.pathname.includes("/paninfcfg") ||
      location.pathname.includes("/macros") ||
      location.pathname.includes("/sfi") ||
      location.pathname.includes("/api")
    ) {
      newActual = 8;
    } else if (
      location.pathname.includes("/impstoart") ||
      location.pathname.includes("/connections")
    ) {
      newActual = 9;
    }

    // Sincronizamos el menú abierto con la sección actual
    if (newActual !== 0) {
        setOpenMenu(newActual);
    }
  }, [location]);

  const handleOpen = (e, indice) => {
    e.preventDefault();
    e.stopPropagation();
    // Si el menú clickeado ya está abierto, lo cerramos (null). Si no, lo abrimos.
    setOpenMenu(openMenu === indice ? null : indice);
  };

  const swalRegenerar = (e) => {
    swal({
      title: confApp.config.trad.components.regstock.titulo.title,
      text: confApp.config.trad.components.regstock.texto.title,
      icon: "warning",
      buttons: {
        cancel: {
          text: confApp.config.trad.components.regstock.btncancelar.title,
          className: "btn btn-flat mr-1 btn-outline-secondary",
          visible: true,
        },
        confirm: {
          text: confApp.config.trad.components.regstock.btnaceptar.title,
          className: "btn btn-flat mr-1 btn-outline-success btnSwalSuccess",
        },
      },
    }).then((confirmacion) => {
      if (confirmacion == true) {
        regenerar();
      }
    });
  };

  const regenerar = async () => {
    saveRegenerando(true);
    saveTextoRegenerando(
      confApp.config.trad.components.regstock.txtaccion.title,
    );
    saveEstReg("");

    const data = new FormData();
    data.append("validacion", apiKey());
    const respuesta = await axios.post(
      getApiUrl(window.location.origin) + "/app/regenerarStock",
      data,
    );
    if (typeof respuesta.data == "string") {
      // alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: false});
      saveEstReg("error");
      saveTextoRegenerando("");
      saveRespReg(respuesta.data);
    } else if (respuesta.data == true) {
      // alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confApp.config.trad.components.regstock.txtok.title}`, {autoClose: false});
      saveEstReg("success");
      saveTextoRegenerando("");
      saveRespReg(confApp.config.trad.components.regstock.txtok.title);
    }

    // saveRegenerando(false);
  };

  return (
    <Fragment>
      {regenerando ? (
        <SpinnerFullScreen
          spinner={regenerando}
          textoSpinner={textoRegenerando}
          respuesta={respReg}
          estado={estReg}
          saveRegenerando={saveRegenerando}
        />
      ) : null}
      {/* <Alert fondo={true} />     */}
      <nav className="mt-2">
        <ul
          className="nav nav-pills nav-sidebar flex-column  nav-child-indent"
          role="menu"
          data-accordion="true">
          <li className="nav-item">
            <NavLink
              to="/checklist/418"
              className="nav-link"
              activeStyle={{ backgroundColor: activeMenuColor }}>
              {/* <i className={confApp.documentos.sidebarmenu.icono} style={{marginRight:5}} /> */}
              <p>CheckList Compresor</p>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/checklist/166"
              className="nav-link"
              activeStyle={{ backgroundColor: activeMenuColor }}>
              {/* <i className={confApp.documentos.sidebarmenu.icono} style={{marginRight:5}} /> */}
              <p>CheckList Depuradora</p>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/gesdoc/28"
              className="nav-link"
              activeStyle={{ backgroundColor: activeMenuColor }}>
              {/* <i className={confApp.documentos.sidebarmenu.icono} style={{marginRight:5}} /> */}
              <p>Ges.Doc SGS-MF</p>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/gesdoc/50"
              className="nav-link"
              activeStyle={{ backgroundColor: activeMenuColor }}>
              {/* <i className={confApp.runciccfg.sidebarmenu.icono} style={{marginRight:5}} /> */}
              <p>Ges.Doc URL Hijo</p>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/inicio"
              className="nav-link"
              activeStyle={{ backgroundColor: activeMenuColor }}
              style={{ paddingLeft: "10px" }}>
              <i className={confApp.documentostrab.sidebarmenu.icono} />
              <p>{confApp.documentostrab.sidebarmenu.titulo}</p>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/checklist"
              className="nav-link"
              activeStyle={{ backgroundColor: activeMenuColor }}
              style={{ paddingLeft: "10px" }}>
              <i className={confApp.checklistma.sidebarmenu.icono} />
              <p>{confApp.checklistma.sidebarmenu.titulo}</p>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/adjcentros"
              className="nav-link"
              activeStyle={{ backgroundColor: activeMenuColor }}
              style={{ paddingLeft: "10px" }}>
              <i className={confApp.centrosadj.sidebarmenu.icono} />
              <p>{confApp.centrosadj.sidebarmenu.titulo}</p>
            </NavLink>
          </li>
          <li
            className={
              openMenu === 1
                ? " nav-item2 menu-open "
                : " nav-item2 "
            }
            onClick={(e) => handleOpen(e, 1)}>
            <a
              href="#"
              className={openMenu === 1 ? "nav-link2 active" : "nav-link2"}
              style={{ paddingLeft: 10 }}>
              <i
                className={
                  confApp.menusuperadmin.nivelessup.documentos.icono
                }></i>
              <p>
                {confApp.menusuperadmin.nivelessup.documentos.titulo}
                <i className="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul id="sub1" className="nav nav-treeview sub">
              <li className="nav-item">
                <NavLink
                  to="/checklist/418"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  {/* <i className={confApp.documentos.sidebarmenu.icono} style={{marginRight:5}} /> */}
                  <p>CheckList Compresor</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/checklist/166"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  {/* <i className={confApp.documentos.sidebarmenu.icono} style={{marginRight:5}} /> */}
                  <p>CheckList Depuradora</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/gesdoc/28"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  {/* <i className={confApp.documentos.sidebarmenu.icono} style={{marginRight:5}} /> */}
                  <p>Ges.Doc SGS-MF</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/gesdoc/50"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  {/* <i className={confApp.runciccfg.sidebarmenu.icono} style={{marginRight:5}} /> */}
                  <p>Ges.Doc URL Hijo</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/documentos"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.documentos.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.documentos.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/runciccfg"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.runciccfg.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.runciccfg.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/planificador"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.planificador.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.planificador.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/edirap"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.edirap.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.edirap.sidebarmenu.titulo}</p>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/tipdoc"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.tipdoc.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.tipdoc.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/estdoc"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.estdoc.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.estdoc.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/apartados"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.apartados.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.apartados.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
            </ul>
          </li>
          <li
            className={
              openMenu === 2
                ? " nav-item2 menu-open "
                : " nav-item2 "
            }
            onClick={(e) => handleOpen(e, 2)}>
            <a
              href="#"
              className={openMenu === 2 ? "nav-link2 active" : "nav-link2"}
              style={{ paddingLeft: 10 }}>
              <i className={confApp.menusuperadmin.nivelessup.stock.icono}></i>
              <p>
                {confApp.menusuperadmin.nivelessup.stock.titulo}
                <i className="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul id="sub2" className="nav nav-treeview sub">
              <li className="nav-item">
                <a
                  onClick={(e) => swalRegenerar(e)}
                  className="nav-link"
                  style={{ cursor: "pointer" }}
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.menusuperadmin.regstock.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.menusuperadmin.regstock.titulo}</p>
                </a>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/stockubi"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.stockubi.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.stockubi.sidebarmenu.titulo}</p>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/stockmov"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.stockmov.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.stockmov.sidebarmenu.titulo}</p>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/stockreu"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.stockreu.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.stockreu.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/stockart"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.stockart.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.stockart.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/supply"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.supply.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.supply.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
            </ul>
          </li>
          <li
            className={
              openMenu === 3
                ? " nav-item2 menu-open "
                : " nav-item2 "
            }
            onClick={(e) => handleOpen(e, 3)}>
            <a
              href="#"
              className={openMenu === 3 ? "nav-link2 active" : "nav-link2"}
              style={{ paddingLeft: 10 }}>
              <i
                className={
                  confApp.menusuperadmin.nivelessup.articulos.icono
                }></i>
              <p>
                {confApp.menusuperadmin.nivelessup.articulos.titulo}
                <i className="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul id="sub3" className="nav nav-treeview sub">
              <li className="nav-item">
                <NavLink
                  to="/articulos"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.articulos.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.articulos.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/tipuni"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.tipuni.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.tipuni.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
            </ul>
          </li>
          <li
            className={
              openMenu === 4
                ? " nav-item2 menu-open "
                : " nav-item2 "
            }
            onClick={(e) => handleOpen(e, 4)}>
            <a
              href="#"
              className={openMenu === 4 ? "nav-link2 active" : "nav-link2"}
              style={{ paddingLeft: 10 }}>
              <i
                className={
                  confApp.menusuperadmin.nivelessup.agentes.icono
                }></i>
              <p>
                {confApp.menusuperadmin.nivelessup.agentes.titulo}
                <i className="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul id="sub4" className="nav nav-treeview sub">
              <li className="nav-item">
                <NavLink
                  to="/agentes"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.agentes.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.agentes.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/tipage"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.tipage.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.tipage.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
            </ul>
          </li>
          <li
            className={
              openMenu === 5
                ? " nav-item2 menu-open "
                : " nav-item2 "
            }
            onClick={(e) => handleOpen(e, 5)}>
            <a
              href="#"
              className={
                openMenu === 5
                  ? "nav-link2 active"
                  : "nav-link2"
              }
              style={{ paddingLeft: 10 }}>
              <i
                className={
                  confApp.menusuperadmin.nivelessup.equipos.icono
                }></i>
              <p>
                {confApp.menusuperadmin.nivelessup.equipos.titulo}
                <i className="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul id="sub5" className="nav nav-treeview sub">
              <li className="nav-item">
                <NavLink
                  to="/equipos"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.equipos.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.equipos.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/tipobj"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.tipobj.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.tipobj.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/apartados"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.apartados.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.apartados.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="nav-item">
            <NavLink
              to="/ubicaciones"
              className={
                location.pathname.includes("/ubicaciones")
                  ? "nav-link active"
                  : "nav-link"
              }
              activeStyle={{ backgroundColor: activeMenuColor }}
              style={{ paddingLeft: 10 }}>
              <i className={confApp.ubicaciones.sidebarmenu.icono} />
              <p>{confApp.ubicaciones.sidebarmenu.titulo}</p>
            </NavLink>
          </li>
          <li
            className={
              openMenu === 6
                ? " nav-item2 menu-open "
                : " nav-item2 "
            }
            onClick={(e) => handleOpen(e, 6)}>
            <a
              href="#"
              className={openMenu === 6 ? "nav-link2 active" : "nav-link2"}
              style={{ paddingLeft: 10 }}>
              <i
                className={
                  confApp.menusuperadmin.nivelessup.centros.icono
                }></i>
              <p>
                {confApp.menusuperadmin.nivelessup.centros.titulo}
                <i className="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul id="sub6" className="nav nav-treeview sub">
              <li className="nav-item">
                <NavLink
                  to="/centros"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.centros.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.centros.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/tipcen"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.tipcen.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.tipcen.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
            </ul>
          </li>
          <li
            className={
              openMenu === 7
                ? " nav-item2 menu-open "
                : " nav-item2 "
            }
            onClick={(e) => handleOpen(e, 7)}>
            <a
              href="#"
              className={openMenu === 7 ? "nav-link2 active" : "nav-link2"}
              style={{ paddingLeft: 10 }}>
              <i
                className={
                  confApp.menusuperadmin.nivelessup.usuarios.icono
                }></i>
              <p>
                {confApp.menusuperadmin.nivelessup.usuarios.titulo}
                <i className="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul id="sub7" className="nav nav-treeview sub">
              <li className="nav-item">
                <NavLink
                  to="/loginusu"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.loginusu.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.loginusu.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/tipgf"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.tipgf.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.tipgf.sidebarmenu.titulo}</p>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/loginnvl"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.loginnvl.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.loginnvl.sidebarmenu.titulo}</p>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/permisosusu"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.permisosusu.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.permisosusu.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
            </ul>
          </li>
          <li
            className={
              openMenu === 8
                ? " nav-item2 menu-open "
                : " nav-item2 "
            }
            onClick={(e) => handleOpen(e, 8)}>
            <a
              href="#"
              className={openMenu === 8 ? "nav-link2 active" : "nav-link2"}
              style={{ paddingLeft: 10 }}>
              <i
                className={
                  confApp.menusuperadmin.nivelessup.configuracion.icono
                }></i>
              <p>
                {confApp.menusuperadmin.nivelessup.configuracion.titulo}
                <i className="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul id="sub8" className="nav nav-treeview sub">
              <li className="nav-item">
                <NavLink
                  to="/ciccfg"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.ciccfg.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.ciccfg.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/api"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.api.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.api.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/sfi"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.sfi.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.sfi.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/tipadj"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.tipadj.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.tipadj.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/paises"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.paises.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.paises.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/provincias"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.provincias.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.provincias.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/appcfg"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.appcfg.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.appcfg.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/apptrad"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.apptrad.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.apptrad.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/paninfcfg"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.paninfcfg.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.paninfcfg.sidebarmenu.titulo}</p>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/macros"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.macros.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.macros.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="nav-item">
            <NavLink
              to="/kpis"
              className={
                location.pathname.includes("/kpis")
                  ? "nav-link active"
                  : "nav-link"
              }
              activeStyle={{ backgroundColor: activeMenuColor }}
              style={{ paddingLeft: 10 }}>
              <i className={confApp.kpis.sidebarmenu.icono} />
              <p>{confApp.kpis.sidebarmenu.titulo}</p>
            </NavLink>
          </li>
          <li
            className={
              openMenu === 9
                ? " nav-item2 menu-open "
                : " nav-item2 "
            }
            onClick={(e) => handleOpen(e, 9)}>
            <a
              href="#"
              className={openMenu === 9 ? "nav-link2 active" : "nav-link2"}
              style={{ paddingLeft: 10 }}>
              <i className={confApp.menusuperadmin.impexp.icono}></i>
              <p>
                {confApp.menusuperadmin.impexp.titulo}
                <i className="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul id="sub9" className="nav nav-treeview sub">
              <li className="nav-item">
                <NavLink
                  to="/connections"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.connections.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.connections.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
            </ul>
            <ul id="sub9" className="nav nav-treeview sub">
              <li className="nav-item">
                <NavLink
                  to="/impstoart"
                  className="nav-link"
                  activeStyle={{ backgroundColor: activeMenuColor }}>
                  <i
                    className={confApp.impstoart.sidebarmenu.icono}
                    style={{ marginRight: 5 }}
                  />
                  <p>{confApp.impstoart.sidebarmenu.titulo}</p>
                </NavLink>
              </li>
            </ul>
            <ul id="sub9" className="nav nav-treeview sub">
              <li className="nav-item">
                <a
                  href={getApiUrl(window.location.origin) + "/reports/activity"}
                  target="_blank"
                  className="nav-link">
                  <i
                    className={
                      confApp.menusuperadmin.informes.subinformes.activity.icono
                    }
                    style={{ marginRight: 5 }}
                  />
                  <p>
                    {confApp.menusuperadmin.informes.subinformes.activity.title}
                  </p>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </Fragment>
  );
}

export default MenuSuperAdmin;
